(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientResultMissingData', PatientResultMissingData);

    PatientResultMissingData.$inject = ['$resource'];

    function PatientResultMissingData ($resource) {
        var resourceUrl =  'api/patient-result-missing-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
